<template>
  <div class="container">
    <div class="tl spread df" style="flex-direction: column">
      <div style="margin: 0 20px">
        <input
          v-model="gtin"
          placeholder="条形码/二维码值（查询时必填）"
          style="width: 240px; background-color: transparent"
          class="input_box"
        />
        <input
          v-model="batchNumber"
          placeholder="批次（非必填）"
          style="width: 200px; background-color: transparent"
          class="input_box"
        />
        <span class="button" @click="handleSearch">查询</span>
        <span class="button" @click="handleRest">重置</span>

        <!-- 模式切换按钮 -->
        <div class="mode-switch" v-if="showModeSwitch">
          <span class="mode-label">模式:</span>
          <el-switch
            v-model="currentMode"
            active-text="模式一"
            inactive-text="模式二"
            inactive-color="#67C23A"
            active-value="1"
            inactive-value="2"
            @change="handleModeChange"
          >
          </el-switch>
        </div>
      </div>
      <div
        style="
          padding: 30px 30px 0px;
          box-sizing: border-box;
          flex: 1;
          min-height: 0;
          position: relative;
        "
      >
        <div class="spread map-container">
          <iframe
            style="width: 100%; height: 100%"
            src="https://e.esunadv.com/GISMap/#/"
            frameborder="0"
            ref="mapIframe"
          ></iframe>
          <!-- <ve-bmap
            v-if="mapShow"
            ref="mapRef"
            height="100%"
            :settings="chartSettings"
            :series="chartSeries"
            :tooltip="chartTooltip"
            :events="chartEvents"
          >
            <div
              class="chain-block-box"
              v-show="companyList && companyList.length > 0"
            >
              Hash值区块链验证:
              <span v-if="!hashFlag" class="hash-value" @click="verifyHash">
                <i class="el-icon-thumb"></i>
                {{ hashVal }}
              </span>
              <span v-else class="hash-result" @click="verifyHash"
                >数据无篡改</span
              >
            </div>
          </ve-bmap> -->
        </div>
      </div>
      <div class="col-fff df aic jcc" style="padding-bottom: 20px">
        默认显示最新50条流向记录
      </div>
    </div>

    <!-- 右侧手机弹窗 -->
    <transition name="slide-right">
      <div v-if="showPhoneModal" class="phone-modal-container">
        <div class="phone-modal">
          <!-- 手机内容区域 -->
          <div class="phone-content">
            <iframe
              :src="phoneUrl"
              frameborder="0"
              class="phone-iframe"
              ref="phoneIframe"
            ></iframe>
          </div>
          <!-- 控制按钮区域 -->
          <div class="control-buttons">
            <!-- 返回按钮 -->
            <el-tooltip content="返回" placement="top">
              <div class="control-button back-button" @click="handleGoBack">
                <i class="el-icon-back"></i>
              </div>
            </el-tooltip>
            <!-- 关闭按钮 -->
            <el-tooltip content="关闭" placement="top">
              <div class="control-button close-button" @click="closePhoneModal">
                <i class="el-icon-close"></i>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { createHash, local } from "@/util/util";
import { mapConfig } from "./custom_map_config.js";
import { hex_md5 } from "./md5.js";

export default {
  data() {
    this.chartSettings = {
      key: "piSYUrFTXubSAUZtRpRC4Awsuo726O3x",
      bmap: {
        center: [120, 30],
        zoom: 5,
        roam: true,
        enableMapClick: false,
        mapStyleV2: { styleJson: mapConfig },
      },
    };
    this.chartTooltip = {
      show: true,
      formatter: function (params, ticket, callback) {
        if (params.seriesType === "effectScatter") {
          // return `${params.marker}${params.value[2]}<br>${params.value[5] || params.value[6]}-${params.value[3]}-${params.value[4]}`;
        } else if (params.seriesType === "lines") {
          return `${params.data.fromName} > ${params.data.toName}<br>
                  ${params.data.goodsName}[${params.data.batch}]<br>
                  发货车辆:${
                    params.data.soCarNumber || "无车辆信息"
                  }-收货车辆:${params.data.rcCarNumber || "无车辆信息"}`;
        }
      },
    };

    const _this = this;
    this.chartEvents = {
      click: (params) => {
        // 点击线条时触发
        if (params.seriesType === "lines") {
          _this.handleLineClick(params.data);
        }
      },
      finished: () => {
        // 地图渲染完成后调整大小
        _this.$nextTick(() => {
          _this.resizeMap();
        });
      },
    };

    return {
      gtin: "",
      batchNumber: "",
      mapShow: false,
      companyList: [],
      chartSeries: [],
      hashFlag: false,
      hashVal: createHash(30),
      // 新增弹窗相关数据
      showPhoneModal: false,
      phoneUrl: "", // iframe加载的URL
      // 模式切换相关
      currentMode: "2", // 默认模式一
      showModeSwitch: false, // 是否显示模式切换
      mapIframe: null, // iframe 引用
      isMapReady: false, // 地图是否已准备好
      pendingRouteData: null, // 等待发送的路线数据
      mapReadyTimeout: null, // 就绪检查定时器
    };
  },
  computed: {},
  watch: {
    // 监听GTIN和批次，当两者都有值时显示模式切换
    gtin(newVal) {
      this.updateModeSwitchVisibility();
    },
    batchNumber(newVal) {
      if (!newVal && this.currentMode === "1") {
        this.currentMode = "2";
        this.$message({
          showClose: true,
          message: "已切换至模式一",
          type: "info",
        });
      }
      this.updateModeSwitchVisibility();
    },
  },
  created() {},
  mounted() {
    // this.initMap();
    window.addEventListener("resize", this.handleResize);
    this.initMapCommunication();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    /**
     * 初始化地图通信
     */
    initMapCommunication() {
      // 获取 iframe 元素
      this.mapIframe = this.$refs.mapIframe;

      // 监听 iframe 的 load 事件
      this.mapIframe.addEventListener("load", this.onIframeLoaded);

      // 监听来自 iframe 的消息
      window.addEventListener("message", this.handleMapMessage);
    },

    /**
     * iframe 加载完成回调
     */
    onIframeLoaded() {
      console.log("iframe DOM 加载完成");

      // 开始检查地图是否完全就绪
      this.startMapReadyCheck();
    },

    /**
     * 开始检查地图是否就绪
     */
    startMapReadyCheck() {
      // 清除之前的定时器
      if (this.mapReadyTimeout) {
        clearInterval(this.mapReadyTimeout);
      }

      // 每 500ms 发送一次就绪检查
      this.mapReadyTimeout = setInterval(() => {
        this.sendMessageToMap({
          type: "get-state",
          data: {},
        });
      }, 500);

      // 10秒后超时停止检查
      setTimeout(() => {
        if (!this.isMapReady && this.mapReadyTimeout) {
          clearInterval(this.mapReadyTimeout);
          console.warn("地图加载超时，可能存在问题");
          this.$message.warning("地图加载超时，请刷新页面重试");
        }
      }, 10000);
    },

    /**
     * 处理来自地图的消息
     */
    handleMapMessage(event) {
      try {
        const data = event.data;

        switch (data.type) {
          case "map-ready":
            console.log("✅ 地图组件已完全初始化");
            this.handleMapReady();
            break;

          case "map-state":
            // 收到地图状态响应，说明地图已就绪
            if (!this.isMapReady) {
              this.handleMapReady();
            }
            break;

          case "draw-complete":
            console.log("路线绘制完成:", data.data);
            // this.$message.success(`已绘制 ${data.data.totalRoutes} 条路线`);
            break;

          case "route-selected":
            console.log("用户选择了一条路线:", data.data);
            this.handleRouteSelected(data.data);
            break;

          default:
            console.log("收到地图消息:", data);
        }
      } catch (error) {
        console.error("处理地图消息出错:", error);
      }
    },

    /**
     * 处理地图就绪
     */
    handleMapReady() {
      this.isMapReady = true;

      // 清除就绪检查定时器
      if (this.mapReadyTimeout) {
        clearInterval(this.mapReadyTimeout);
        this.mapReadyTimeout = null;
      }

      // 发送通知
      // this.$message.success("地图已就绪");
      this.initMap();
      // 如果有等待的数据，现在发送
      // if (this.pendingRouteData) {
      //   setTimeout(() => {
      //     this.drawRoutes(this.pendingRouteData);
      //     this.pendingRouteData = null;
      //   }, 300);
      // }
    },

    /**
     * 发送消息到地图
     */
    sendMessageToMap(message) {
      if (!this.mapIframe || !this.mapIframe.contentWindow) {
        console.warn("iframe 未找到或未加载完成");
        return false;
      }

      try {
        this.mapIframe.contentWindow.postMessage(message, "*");
        return true;
      } catch (error) {
        console.error("发送消息到地图失败:", error);
        return false;
      }
    },

    /**
     * 绘制路线
     * @param {Array} routeData - 路线数据数组
     */
    drawRoutes(routeData) {
      if (!Array.isArray(routeData)) {
        console.error("路线数据必须为数组");
        // this.$message.error("路线数据格式错误");
        return;
      }

      if (!this.isMapReady) {
        console.log("地图未就绪，数据已缓存，等待就绪后发送");
        this.pendingRouteData = routeData;
        this.$message.info("地图加载中，数据已排队等待");
        return;
      }

      console.log("开始绘制路线，数据量:", routeData.length);

      const result = this.sendMessageToMap({
        type: "draw-lines",
        data: routeData,
      });

      if (!result) {
        // this.$message.error("发送数据到地图失败");
      }
    },

    /**
     * 清除地图上的所有路线
     */
    clearMap() {
      if (!this.isMapReady) {
        this.$message.warning("地图未就绪");
        return;
      }

      this.sendMessageToMap({
        type: "clear-all",
      });

      // this.$message.success("已清除所有路线");
    },

    /**
     * 获取地图状态
     */
    getMapStatus() {
      if (!this.isMapReady) {
        this.$message.warning("地图未就绪");
        return;
      }

      this.sendMessageToMap({
        type: "get-state",
      });
    },

    /**
     * 处理选中的路线
     */
    handleRouteSelected(routeData) {
      // 这里可以处理用户在地图上选择的路线
      // console.log("用户在地图上选择了路线:", routeData);

      // 例如：显示路线详情
      // this.$message.info(`选择了路线: ${routeData.info?.name || "未知货物"}`);

      // 你可以根据需要将路线数据传递给其他组件
      // this.$emit("route-selected", routeData);
      this.handleLineClick({
        gtin: routeData.info.gtin,
        batch: routeData.info.batchNumber,
        fromCompanyId: routeData.from.companyId,
      });
    },

    /**
     * 销毁时的清理工作
     */
    cleanup() {
      // 移除事件监听器
      if (this.mapIframe) {
        this.mapIframe.removeEventListener("load", this.onIframeLoaded);
      }
      window.removeEventListener("message", this.handleMapMessage);

      // 清除定时器
      if (this.mapReadyTimeout) {
        clearInterval(this.mapReadyTimeout);
      }
    },
    // 更新模式切换按钮的显示状态
    updateModeSwitchVisibility() {
      this.showModeSwitch = !!this.gtin && !!this.batchNumber;
    },

    // 模式切换处理
    handleModeChange() {
      this.$message({
        showClose: true,
        message: `已切换到${this.currentMode === "1" ? "模式一" : "模式二"}`,
        type: "success",
      });
      this.showPhoneModal = false;
      // 重新加载地图数据
      if (this.gtin) {
        this.initMap();
      }
    },

    initMap(params) {
      const loading = this.$loading({
        target: document.querySelector(".map-container"),
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.mapShow = false;
      this.chartSeries = [];
      let user = local.get("user");

      // 根据当前模式设置请求参数
      let data = {
        opt: 2,
        gtin: this.gtin,
        batchNumber: this.batchNumber,
      };

      // 模式一需要添加mode参数
      if (this.currentMode === "1") {
        data.mode = 1;
      }

      if (user.user_type === 4) {
        data.companyId = local.get("company_id");
      }

      this.$extraApi
        .get(`/v1/pc/flow/goods`, data)
        .then((response) => {
          let res = response.data;
          if (res.length > 0) {
            setTimeout(() => {
              this.drawRoutes(res);
              this.pendingRouteData = null;
            }, 100);
            // let convertData = this.convertData(res);
            // let arr = [];
            // let planePath =
            //   "path://M.6,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705";
            // convertData.forEach((item, index) => {
            //   arr.push(
            //     {
            //       type: "effectScatter",
            //       coordinateSystem: "bmap",
            //       zlevel: 2,
            //       rippleEffect: {
            //         period: 4,
            //         brushType: "stroke",
            //         scale: 4,
            //       },
            //       symbol: "circle",
            //       itemStyle: {
            //         normal: {
            //           color: "#3ed4ff",
            //         },
            //       },
            //       data: item.fromData,
            //     },
            //     {
            //       type: "effectScatter",
            //       coordinateSystem: "bmap",
            //       zlevel: 2,
            //       rippleEffect: {
            //         period: 4,
            //         brushType: "stroke",
            //         scale: 4,
            //       },
            //       symbol: "circle",
            //       itemStyle: {
            //         normal: {
            //           color: "#3ed4ff",
            //         },
            //       },
            //       data: item.toData,
            //     },
            //     {
            //       type: "lines",
            //       coordinateSystem: "bmap",
            //       zlevel: 1,
            //       effect: {
            //         show: true,
            //         period: 6,
            //         trailLength: 0.7,
            //         color: "#fff",
            //         symbolSize: 3,
            //       },
            //       lineStyle: {
            //         normal: {
            //           color: "#3ed4ff",
            //           width: 0,
            //           curveness: 0.2,
            //         },
            //       },
            //       data: item.lineData,
            //     },
            //     {
            //       type: "lines",
            //       coordinateSystem: "bmap",
            //       zlevel: 2,
            //       effect: {
            //         show: true,
            //         period: 6,
            //         trailLength: 0,
            //         symbol: planePath,
            //         symbolSize: 15,
            //       },
            //       lineStyle: {
            //         normal: {
            //           color: "#3ed4ff",
            //           width: 1,
            //           opacity: 0.4,
            //           curveness: 0.2,
            //         },
            //       },
            //       data: item.lineData,
            //     }
            //   );
            // });
            // this.chartSeries = arr;
          }
          // this.mapShow = true;
          // this.getGeo();

          // 确保地图正确渲染
          this.$nextTick(() => {
            setTimeout(() => {
              this.resizeMap();
              loading.close();
            }, 300);
          });
        })
        .catch(() => {
          loading.close();
        });
    },

    // 重置地图大小
    resizeMap() {
      if (this.$refs.mapRef && this.$refs.mapRef.echarts) {
        const echarts = this.$refs.mapRef.echarts;
        setTimeout(() => {
          if (echarts && typeof echarts.resize === "function") {
            echarts.resize();
          }
        }, 100);
      }
    },

    // 窗口大小变化处理
    handleResize() {
      this.resizeMap();
    },

    handleSearch() {
      if (this.gtin) {
        this.initMap();
      } else {
        this.$message({
          showClose: true,
          message: "条形码/二维码值为必填项",
          type: "warning",
        });
      }
    },
    handleRest() {
      this.gtin = "";
      this.batchNumber = "";
      this.currentMode = "2"; // 重置时切换回模式一
      this.showModeSwitch = false; // 隐藏模式切换
      this.showPhoneModal = false;
      this.initMap();
    },
    afterSet: function (echarts) {
      var bmap = echarts.getModel().getComponent("bmap").getBMap();
      bmap.addControl(new window.BMap.MapTypeControl());
    },
    convertData(data) {
      let result = [];
      let companyList = [];
      let afterData = [];
      let tempArr = [];

      for (let i = 0; i < data.length; i++) {
        let fromData = [];
        let toData = [];
        let lineData = [];
        let fromLong = data[i].from.longitude;
        let fromLat = data[i].from.latitude;
        let toLong = data[i].to.longitude;
        let toLat = data[i].to.latitude;
        fromData = [[fromLong, fromLat, data[i].from.companyName]];
        companyList.push({
          longitude: fromLong,
          latitude: fromLat,
        });
        toData = [[toLong, toLat, data[i].to.companyName]];

        // 构建lineData，根据模式决定是否包含fromCompanyId
        let lineItem = {
          fromName: data[i].from.companyName,
          fromCompanyId: data[i].from.companyId,
          toName: data[i].to.companyName,
          goodsName: data[i].info.name,
          gtin: data[i].info.gtin,
          batch: data[i].info.batchNumber,
          soCarNumber: data[i].info.fromCarNumber,
          rcCarNumber: data[i].info.toCarNumber,
          coords: [
            [fromLong, fromLat],
            [toLong, toLat],
          ],
        };
        lineData = [lineItem];

        companyList.push({
          longitude: toLong,
          latitude: toLat,
        });
        result.push({ fromData, toData, lineData });
      }
      this.companyList = companyList;
      return result;
    },
    getGeo() {
      if (this.companyList.length > 0) {
        setTimeout((_) => {
          let pointArr = [];
          this.companyList.forEach((item) => {
            pointArr.push(new window.BMap.Point(item.longitude, item.latitude));
          });
          let echarts = this.$refs.mapRef.echarts;
          let map = echarts.getModel().getComponent("bmap").getBMap();
          let view = map.getViewport(eval(pointArr));
          let mapZoom = view.zoom > 2 ? view.zoom - 1 : view.zoom;
          let centerPoint = view.center;
          map.centerAndZoom(centerPoint, mapZoom);
        }, 200);
      }
    },
    verifyHash() {
      this.hashFlag = !this.hashFlag;
    },

    // 新增方法：处理线条点击事件
    handleLineClick(lineData) {
      console.log(lineData);

      // 只有模式一才显示手机弹窗
      let qrString = "";
      let baseUrl = "https://e.esunadv.com/";
      if (lineData.gtin.substr(0, 2) !== "01" || lineData.gtin.length < 14) {
        qrString =
          baseUrl +
          "we_dist/#/scan/01/" +
          lineData.gtin +
          "/10/" +
          lineData.batch +
          "/91/" +
          lineData.fromCompanyId +
          "/21/" +
          hex_md5(new Date().getTime());
      } else {
        qrString =
          baseUrl +
          "we_dist/#/scan?barcode=" +
          lineData.gtin +
          "&batch=" +
          lineData.batch +
          "&companyId=" +
          lineData.fromCompanyId +
          "&stamp=" +
          hex_md5(new Date().getTime());
      }
      console.log(qrString);

      this.phoneUrl = qrString;

      // 显示弹窗
      this.showPhoneModal = true;

      // 延迟设置iframe的视口，确保以移动设备模式显示
      this.$nextTick(() => {
        this.setMobileViewport();
      });
    },

    // 设置移动设备视口
    setMobileViewport() {
      try {
        const iframe = this.$refs.phoneIframe;
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage(
            {
              type: "SET_VIEWPORT",
              viewport:
                "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no",
            },
            "*"
          );
        }
      } catch (e) {
        console.log("无法设置iframe视口:", e);
      }
    },

    // 返回上一页
    handleGoBack() {
      try {
        const iframe = this.$refs.phoneIframe;
        if (iframe && iframe.contentWindow) {
          // 向iframe发送返回上一页的消息
          iframe.contentWindow.postMessage(
            {
              type: "GO_BACK",
            },
            "*"
          );
        }
      } catch (e) {
        console.log("无法发送返回消息:", e);

        // 备用方案：尝试直接调用iframe的history.back()
        try {
          const iframe = this.$refs.phoneIframe;
          if (iframe && iframe.contentWindow && iframe.contentWindow.history) {
            iframe.contentWindow.history.back();
          }
        } catch (backError) {
          console.log("备用返回方案也失败:", backError);
        }
      }
    },

    // 关闭手机弹窗
    closePhoneModal() {
      this.showPhoneModal = false;
      this.phoneUrl = "";
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.tl.spread.df {
  flex: 1;
  min-height: 0;
}

.map-container {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 20px;

  // 确保地图容器正确渲染
  :deep(.ve-bmap) {
    height: 100% !important;
    width: 100% !important;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    // ECharts 容器
    > div {
      height: 100% !important;
      width: 100% !important;
      position: absolute !important;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    // Canvas 层
    canvas {
      display: block !important;
    }
  }
}

.input_box {
  border: 2px solid #409eff;
  color: #f2f6fc;
  height: 40px;
  border-radius: 15px;
  text-align: center;
  vertical-align: middle;
  margin-right: 10px;
}
$color: #2194e0;
@keyframes sheen {
  0% {
    transform: skewY(-45deg) translateX(0);
  }
  100% {
    transform: skewY(-45deg) translateX(12.5em);
  }
}
.button {
  width: 80px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  text-decoration: none;
  color: #d3d7d4;
  border: 2px solid $color;
  font-size: 16px;
  display: inline-block;
  border-radius: 15px;
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;
  margin-right: 10px;

  &:before {
    content: "";
    background-color: rgba(255, 255, 255, 0.5);
    height: 100%;
    width: 3em;
    display: block;
    position: absolute;
    top: 0;
    left: -4.5em;
    transform: skewX(-45deg) translateX(0);
    transition: none;
  }

  &:hover {
    cursor: pointer;
    background-color: $color;
    color: #fff;
    border-bottom: 4px solid darken($color, 10%);

    &:before {
      transform: skewX(-45deg) translateX(13.5em);
      transition: all 0.5s ease-in-out;
    }
  }
}

/* 模式切换样式 */
.mode-switch {
  display: inline-flex;
  align-items: center;
  margin-left: 15px;
  border: 2px solid $color;
  padding: 0 20px;
  height: 40px;
  border-radius: 15px;

  .mode-label {
    color: #f2f6fc;
    margin-right: 8px;
    font-size: 14px;
  }

  /* 自定义开关样式以匹配现有风格 */
  :deep(.el-switch) {
    .el-switch__label {
      color: #f2f6fc;
      &.is-active {
        color: #409eff;
      }
    }

    .el-switch__core {
      border-color: #409eff;
      background-color: transparent;

      &::after {
        background-color: #409eff;
      }
    }

    &.is-checked .el-switch__core {
      border-color: #409eff;
      background-color: #409eff;
    }
  }
}

input::-webkit-input-placeholder {
  color: #afb4db;
}
input:-moz-placeholder {
  color: #afb4db;
}
input::-moz-placeholder {
  color: #afb4db;
}
input:-ms-input-placeholder {
  color: #afb4db;
}
.chain-block-box {
  position: absolute;
  top: 28px;
  left: 15px;
  z-index: 1099;
  padding: 5px 10px;
  background-color: #1a366a;
  color: #f2f6fc;
  cursor: default;
}
.hash-value {
  color: #409eff;
  cursor: pointer;
}
.hash-result {
  color: #67c23a;
  cursor: pointer;
}
.spread {
  height: 100%;
}

/* 右侧滑入滑出动画 */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.5s ease;
}

.slide-right-enter {
  opacity: 0;
  transform: translateX(100%);
}

.slide-right-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.slide-right-leave {
  opacity: 1;
  transform: translateX(0);
}

.slide-right-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

/* 新增样式：右侧手机弹窗 */
.phone-modal-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  pointer-events: none;
  z-index: 1000;
}

.phone-modal {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

/* 手机内容区域 */
.phone-content {
  width: 390px;
  height: 844px;
  background-color: #fff;
  border-radius: 48px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  position: relative;
}

.phone-iframe {
  width: 100%;
  height: 100%;
  border: none;
  -webkit-overflow-scrolling: touch;
}

/* 控制按钮区域 - 横向排列 */
.control-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  margin-top: 10px;
  width: 100%;
  justify-content: center;
}

/* 控制按钮通用样式 */
.control-button {
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;

  &:hover {
    background-color: #fff;
    transform: scale(1.1);
  }

  i {
    font-size: 20px;
    color: #333;
  }
}

/* 响应式调整 */
@media (min-width: 1921px) and (max-width: 2559px) {
  /* 2K屏幕调整 */
  .phone-content {
    width: 450px;
    height: 974px;
    border-radius: 55px;
  }

  .phone-modal {
    right: 30px;
  }

  .control-buttons {
    gap: 20px;
    margin-top: 25px;
  }

  .control-button {
    width: 45px;
    height: 45px;

    i {
      font-size: 22px;
    }
  }
}

@media (min-width: 2560px) {
  /* 4K屏幕调整 */
  .phone-content {
    width: 520px;
    height: 1124px;
    border-radius: 62px;
  }

  .phone-modal {
    right: 40px;
  }

  .control-buttons {
    gap: 25px;
    margin-top: 30px;
  }

  .control-button {
    width: 50px;
    height: 50px;

    i {
      font-size: 24px;
    }
  }
}

/* 针对超小屏幕的额外调整 */
@media (max-height: 800px) {
  .phone-content {
    height: 700px;
    width: 324px;
  }

  .phone-modal {
    top: 60%;
  }

  .control-buttons {
    margin-top: 15px;
  }
}

/* 超大屏幕额外优化 */
@media (min-width: 3840px) {
  .phone-content {
    width: 580px;
    height: 1254px;
    border-radius: 68px;
  }

  .phone-modal {
    right: 60px;
  }

  .control-buttons {
    gap: 30px;
    margin-top: 35px;
  }

  .control-button {
    width: 55px;
    height: 55px;

    i {
      font-size: 26px;
    }
  }
}

::v-deep .el-switch__label {
  color: #fff;
}
::v-deep .is-active {
  color: #409eff !important;
}
</style>